import React, { useCallback, useState } from 'react'
import { Button } from '@wmgtech/legato'

import { ConditionRender, FormAdminContainer } from 'components'
import { InfoForm, LabelForm, LocalTags, Tags, UnitForm } from 'modules/Labels/components'
import { useServiceUpdateLabel, useServiceTags } from '../serviceHooks'
import { Can } from 'shared/abilities'
import { subject } from '@casl/ability'
import { Errors } from 'pages/Errors'
import { useParams } from 'react-router-dom'
import { TRouterParams } from 'shared/types'
import { useZoneTemplates } from '../serviceHooks/useGetZoneTemplates'

const EditLabelContainer = () => {
  const { id } = useParams<TRouterParams>()
  const {
    defaultLabelValues,
    units,
    currentLabel,
    onCreateUnit,
    onUpdateUnit,
    countryOptions,
    onSubmitLabel,
    onUpdateTemplate,
    onCreateTemplate,
    isLocalEditable,
    isUpdateLoading,
    notificationMessageVar
  } = useServiceUpdateLabel(id)
  const { templatesList } = useZoneTemplates(id as string)
  const {
    tags,
    onCreateTag,
    onUpdateTag,
    onToggleTag,
    labelTagsIds,
  } = useServiceTags(id)

  const [templateValues, setTemplateValues] = useState<any>({})

  const handleSubmit = useCallback(() => {
    Object.keys(templateValues).forEach((templateType) => {
      const template = templateValues[templateType]
      if (template.id) {
        onUpdateTemplate(template.id, template.value)
      } else {
        onCreateTemplate({
          template_type: templateType,
          label_id: template.label_id,
          template: template.value
        })
      }
    })
  }, [templateValues, onUpdateTemplate, onCreateTemplate])
  if (!currentLabel) return null
  return (
    <Can passThrough={true} I={'edit'} this={subject('Zone', { ...currentLabel })}>
      {(allowed) => allowed ? (
        <>
          <FormAdminContainer
            backLink="/admin/labels"
            actions={
              <Button
                containerStyle="solid"
                colorType="secondary-black"
                label={'Save'}
                form="label-form"
                htmlType="submit"
                onClick={handleSubmit}
              />
            }
          >
            <ConditionRender
              condition={!!currentLabel}
              component={
                <>
                  <LabelForm
                    countryOptions={countryOptions}
                    onSubmit={onSubmitLabel}
                    defaultValues={defaultLabelValues}
                    key={currentLabel?.id}
                    isUpdate
                  />
                  <UnitForm
                    onCreateUnit={onCreateUnit}
                    onUpdateUnit={onUpdateUnit}
                    units={units}
                    key={`${units.length}${isUpdateLoading}`}
                    setShowAlert={notificationMessageVar}
                  />
                  <Tags
                    tags={tags}
                    labelTagsIds={labelTagsIds}
                    onToggleTag={onToggleTag}
                    setShowAlert={notificationMessageVar}
                  />
                  <LocalTags
                    tags={tags}
                    onCreateTag={onCreateTag}
                    onUpdateTag={onUpdateTag}
                    isLocalEditable={isLocalEditable}
                    setShowAlert={notificationMessageVar}
                    key={tags.length}
                  />
                </>
              }
            />
          </FormAdminContainer>
          <InfoForm setTemplateValues={setTemplateValues} templates={templatesList} />
        </>
      ) : (
        <Errors.Unauthorized />
      )}
    </Can>
  )
}

export default EditLabelContainer
